import { CircularProgress, Stack } from "@mui/material";
import React from "react";

const FullLoading = ({ width = "100%", height = "100vh", size = 40 }) => {
  return (
    <Stack
      width={width}
      height={height}
      justifyContent="center"
      alignItems="center"
    >
      <CircularProgress size={size} />
    </Stack>
  );
};

export default FullLoading;
